import {FiltersModel, SearchModel} from '../interfaces';

function brandsAreEqual(brandA: string, brandB: string): boolean {
    return brandA.toLowerCase() === brandB.toLowerCase();
}

export function isSearchedSectionEmptyDueToAnalogBrandFilter(
    filters: FiltersModel,
    searchBrand: string,
    results: SearchModel
): boolean {
    if (results.searched.length > 0 || results.analogs.length === 0 || !searchBrand) {
        return false;
    }

    const selectedBrands = filters.brands.filter((brand) => brand.isSelected);
    const hasPartialBrandFilter =
        selectedBrands.length > 0 && selectedBrands.length < filters.brands.length;

    if (!hasPartialBrandFilter) {
        return false;
    }

    const isSearchBrandSelected = selectedBrands.some((brand) =>
        brandsAreEqual(brand.brandName, searchBrand)
    );

    if (isSearchBrandSelected) {
        return false;
    }

    return results.analogs.some((item) =>
        selectedBrands.some((brand) => brandsAreEqual(brand.brandName, item.header.brandName))
    );
}

export const hasActiveFilters = (filters: FiltersModel): boolean => {
    const hasBrandSelected = filters.brands.some((brand) => brand.isSelected);
    const hasPriceRange =
        filters.priceRange.from !== undefined || filters.priceRange.to !== undefined;
    const hasDeliveryRange =
        filters.deliveryDayRange.from !== undefined || filters.deliveryDayRange.to !== undefined;
    const hasRatingRange =
        filters.ratingRange.from !== undefined || filters.ratingRange.to !== undefined;
    const hasQuantityRange =
        filters.quantityRange.from !== undefined || filters.quantityRange.to !== undefined;

    const hasOfficialDealer = filters.isOfficialDealer;
    const hasReturnPossible = filters.isReturnPossible;
    const hasFavoritePriceList = filters.favorite_price_list;
    const hasBannedPriceList = filters.banned_price_list;
    const hasPriceLevel = filters.priceLevel;

    return (
        hasBrandSelected ||
        hasPriceRange ||
        hasDeliveryRange ||
        hasRatingRange ||
        hasQuantityRange ||
        hasOfficialDealer ||
        hasReturnPossible ||
        hasFavoritePriceList ||
        hasBannedPriceList ||
        hasPriceLevel
    );
};

export const countActiveFilters = (filters: FiltersModel): number => {
    let count = 0;

    if (filters.brands.some((brand) => brand.isSelected)) count++;
    if (filters.priceRange.from !== undefined || filters.priceRange.to !== undefined) count++;
    if (filters.deliveryDayRange.from !== undefined || filters.deliveryDayRange.to !== undefined)
        count++;
    if (filters.ratingRange.from !== undefined || filters.ratingRange.to !== undefined) count++;
    if (filters.quantityRange.from !== undefined || filters.quantityRange.to !== undefined) count++;

    if (filters.isOfficialDealer) count++;
    if (filters.isReturnPossible) count++;
    if (filters.favorite_price_list) count++;
    if (filters.banned_price_list) count++;
    if (filters.priceLevel) count++;

    return count;
};
